import { render, staticRenderFns } from "./PaIncomeSetting.vue?vue&type=template&id=247c4a10&scoped=true"
import script from "./PaIncomeSetting.vue?vue&type=script&lang=js"
export * from "./PaIncomeSetting.vue?vue&type=script&lang=js"
import style0 from "./PaIncomeSetting.vue?vue&type=style&index=0&id=247c4a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c4a10",
  null
  
)

export default component.exports